var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.st0 {\n    fill: #8400e6;\n}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.568,162.666v-3.56c0-8.61-7.005-15.617-15.615-15.617H293.6v-20.714 c18.519-12.539,29.548-33.264,29.548-55.624c0-37.026-30.122-67.15-67.148-67.15c-37.024,0-67.146,30.124-67.146,67.15 c0,22.36,11.029,43.086,29.548,55.624v20.714h-21.353c-8.61,0-15.615,7.007-15.615,15.617v3.56h-160.6V512h470.337V162.666H330.568 z M255.999,45.143c12.137,0,22.013,9.872,22.013,22.007c0,12.139-9.876,22.01-22.013,22.01c-12.137,0-22.011-9.872-22.011-22.01 C233.988,55.015,243.862,45.143,255.999,45.143z M330.568,213.465v-16.281H456.65v280.297H55.348V197.184h126.084v16.281H330.568z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.729,408.282c-1.456-8.012-6.743-14.821-14.204-18.245l-29.773-12.166c-4.4-2.022-7.244-6.456-7.244-11.3 v-4.39c0-1.91,0.316-3.789,0.708-5.152c0.778-1.04,19.084-25.741,19.084-49.091c0-28.396-18.01-49.01-42.824-49.01 c-24.814,0-42.824,20.613-42.824,49.01c0,23.35,18.307,48.051,18.857,48.656c0.621,1.798,0.935,3.68,0.935,5.586v4.39 c0,4.845-2.843,9.278-7.18,11.273l-29.899,12.22c-7.399,3.397-12.686,10.206-14.162,18.377l-1.665,21.49h151.876L408.729,408.282z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.504,
    y: 270.313,
    className: "st0",
    width: 154.085,
    height: 35.342
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.504,
    y: 334.633,
    className: "st0",
    width: 119.45,
    height: 35.341
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.504,
    y: 398.953,
    className: "st0",
    width: 119.45,
    height: 35.346
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersIcon);
export default __webpack_public_path__ + "static/media/MembersIcon.3f84416e608927fe7e8154491fa343a8.svg";
export { ForwardRef as ReactComponent };